import { error, finish } from '../../../modules/grades/actions/create';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';
import { request as getGradesListAction } from 'src/modules/grades/actions/get-list';

function buildOldValue(value) {
    if (value === null) {
        return null;
    }

    if (value === undefined) {
        return undefined;
    }

    return $appState.configState.precision.valueOldFormat(new Amount(value));
}


function buildValue(value) {
    if (value === null) {
        return null;
    }
    if (value === undefined) {
        return undefined;
    }

    return $appState.configState.precision.newFromOld(value).value;
}

export function request(dispatch, { sportId, data }) {
    data.defaultLimits = {
        liabilityLimit: buildOldValue(data.defaultLimits.liabilityLimit),
        maxBet: buildOldValue(data.defaultLimits.maxBet),
        maxMultipleBet: buildOldValue(data.defaultLimits.maxMultipleBet),
        maxWin: buildOldValue(data.defaultLimits.maxWin)
    };

    api.post(`/sports/${sportId}/grades`, data).then((resp) => {
        dispatch(getGradesListAction(sportId));
    });
}
